// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"b7956a3d","205":"4cc369d2","413":"21cfc7ee","432":"15648e32","453":"8a969a85","531":"b649f7f1","761":"c7f481a8","768":"83fd316b","908":"37d81000"}[chunkId] + ".chunk.js";
};